import React from 'react';
import { useIntl } from 'react-intl';
import schemaPassendeProdukte from './schema.js';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';

const PassendeProdukteBlockData = (props) => {
  const { block, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = schemaPassendeProdukte({ ...props, intl });

  return (
    <BlockDataForm
      block={block}
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      onChangeBlock={onChangeBlock}
      formData={data}
    />
  );
};

export default PassendeProdukteBlockData;
